import { BuiltinInterface } from '../../BuiltinInterface';
import { BuiltinValueObject } from '../../BuiltinValueObject';
import { AddressFrom } from './from';
import { AddressIsCaller } from './isCaller';
import { AddressIsSender } from './isSender';
class AddressInterface extends BuiltinInterface {
}
class AddressValue extends BuiltinValueObject {
    constructor() {
        super(...arguments);
        this.type = 'AddressConstructor';
    }
}
class AddressConstructorInterface extends BuiltinInterface {
}
export const add = (builtins) => {
    builtins.addContractInterface('Address', new AddressInterface());
    builtins.addContractValue('Address', new AddressValue());
    builtins.addContractInterface('AddressConstructor', new AddressConstructorInterface());
    builtins.addContractMember('AddressConstructor', 'from', new AddressFrom());
    builtins.addContractMember('AddressConstructor', 'isSender', new AddressIsSender());
    builtins.addContractMember('AddressConstructor', 'isCaller', new AddressIsCaller());
};

//# sourceMappingURL=index.js.map
